module.exports = __webpack_public_path__ + "img/page-500.df00d549.png";